import { whiteColor, blackColor, hexToRgb } from "../../lib/style";

const styles = (theme) => ({
  wrapper: {
    // height: "auto",
    minHeight: "100vh",
    position: "relative",
    top: "0",
    overflow: "auto",
  },
  fullPage: {
    position: "relative",
    minHeight: "100vh",
    display: "flex!important",
    margin: "0",
    border: "0",
    color: whiteColor,
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100%",
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
      border: "none !important",
    },
    "&:before,&:after": {
      display: "block",
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
    },
  },
  dark: {
    "&:before": {
      backgroundColor: "rgba(" + hexToRgb(blackColor) + ", 0.0)",
    },
  },
  photoCredit: {
    position: "fixed",
    bottom: 10,
    right: 20,
    width: "auto",
    backgroundColor: theme.palette.info,
    color: "white",
    // color: theme.palette.text.primary,
    padding: "10px 3px",
    borderRadius: 5,
    zIndex: 3,
  },
});

export default styles;
